import { createContext, useState } from 'react';
import api from 'services/api';

const filter = {
  like: '',
  id: '',
  filial: [],
  local: [],
  endereco: '',
  produto: [],
  referencia: '',
  variacao: [],
  rastreabilidade: '',
  entidade_id: '',
  entidade: [],
  validade: {
    i: null,
    f: null,
  },
};

export const EstoqueContext = createContext();

export const EstoqueProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [postLoading, setPostLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [estoque, setEstoque] = useState({
    data: [],
    colunas: [],
    filter,
    page: 0,
    size: 10,
  });

  const getEstoque = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: estoque?.filter,
        page: estoque?.page,
        size: estoque?.size,
        order: estoque?.order,
        ...payload,
      });
      setEstoque((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const getTransferencia = async ({ params, cb = null }) => {
    try {
      setGetLoading(true);
      const { data } = await api.get(`/WMS/Estoque/Transferencia`, { params });
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const getTransferenciaSaldo = async ({ params, cb }) => {
    try {
      setGetLoading(true);
      const { data } = await api.get('/Wms/Estoque/Transferencia/Saldo', {
        params,
      });
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const postTransferencia = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Wms/Estoque/Transferencia', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const postTransferenciaEndereco = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Wms/Estoque/Transferencia/Endereco', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const deleteTransferencia = async ({ id, cb }) => {
    try {
      setDeleteLoading(true);
      await api.delete(`/Wms/Estoque/Transferencia/${id}`);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setDeleteLoading(false);
    }
  };

  return (
    <EstoqueContext.Provider
      value={{
        estoque,
        getEstoque,
        getLoading,
        postLoading,
        deleteLoading,
        getTransferencia,
        postTransferencia,
        deleteTransferencia,
        getTransferenciaSaldo,
        postTransferenciaEndereco,
      }}
    >
      {children}
    </EstoqueContext.Provider>
  );
};
